
export type IssueReceipt200 = {
  message?: string;
  receiptId?: string;
  receiptUrl?: string;
  success: boolean;
};
